import { EventEmitter, Injectable, Output } from '@angular/core';
import { RouteInfo } from '../models/IMenuItem';

@Injectable({providedIn: 'root'})
export class EventsService {

  @Output() defaultTenantdbChanged: EventEmitter<string> = new EventEmitter();
  @Output() currentTenantDbChnaged : EventEmitter<string> = new EventEmitter();
  @Output() menuItemsChanged: EventEmitter<RouteInfo[]> = new EventEmitter();
  @Output() currentTenantIdChanged: EventEmitter<string> = new EventEmitter();
  @Output() currentTenantNameChanged: EventEmitter<string> = new EventEmitter();
  @Output() currentUserNameChanged: EventEmitter<string> = new EventEmitter();
  @Output() tempTenantNameChanged: EventEmitter<string> = new EventEmitter();
  @Output() tempTenantIdChanged: EventEmitter<string> = new EventEmitter();
  // Nach dem Schliessen des "Benutzerprofil"-Dialogs, falls sich dabei eine
  // Mandanten-Einladung bestaetigt/abgelehnt haben koennte - die Mandantenliste
  // (select-tenant) hoert darauf, um ihre bereits geladenen Daten aufzufrischen.
  @Output() userTenantsChanged: EventEmitter<void> = new EventEmitter();

  constructor() { }
}
